import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

import { FilterGroupsScreen } from './filterGroups/FilterGroupsScreen';
import { GeolocationManagementScreen } from './geolocations/management/GeolocationManagementScreen';
import { MessageSettingsScreen } from './messages/MessageSettingsScreen';
import OrganizationSettingsManagementRoute from './organization-settings-management/OrganizationSettingsManagementRoute';
import { PaymentsConnectScreen } from './payments/PaymentsConnectScreen';
import { TagManagementRoute } from './tag/management/TagManagementRoute';
import { TripRequestFormScreen } from './trip-request-form/TripRequestFormScreen';

export const settingsRoutes: RouteObject[] = [
  {
    index: true,
    element: <OrganizationSettingsManagementRoute />,
  },
  {
    path: 'tags',
    element: <TagManagementRoute />,
  },
  {
    path: 'payments',
    element: <PaymentsConnectScreen />,
  },
  {
    path: 'filter-groups',
    element: <FilterGroupsScreen />,
  },
  {
    path: 'geolocations',
    element: <GeolocationManagementScreen />,
  },
  {
    path: 'messages',
    element: <MessageSettingsScreen />,
  },
  {
    path: 'trip-request-form',
    element: <TripRequestFormScreen />,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/settings"
        linkText="Go back to settings"
      />
    ),
  },
];
